module.exports = __webpack_public_path__ + "img/1970East-039_WEB-min.072fbf84.jpg";